<template>
  <loader
    ref="hi"
    :key="baseKey"
    :show.sync="show"
    :labelPosition="labelPosition"
    :wd.sync="wd"
    :prms.sync="prms"
    @on-task-posted="taskPosted"
    @on-edit-close="editClose"
    @on-attach="$emit('on-attach', $event)"
    v-if="otCompName != ''"
    :disablePreEditCheck="disablePreEditCheck"
    :otCompName.sync="otCompName"
  />
</template>
<script>
import loader from "@/components/task/edit/base/loader.vue";
import { request } from "@/api/all";
export default {
  name: "taskEditBase",
  components: {
    loader
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    wd: {
      type: String,
      default: () => "95%"
    },
    prms: {
      type: Object,
      default: () => {}
    },
    disablePreEditCheck: {
      type: Boolean,
      default: () => false
    },
    labelPosition:{
      type: String,
      default: () => "left",
    }
  },
  data() {
    return {
      baseKey: 0,
      otCompName: ""
    };
  },
  mounted() {
    //console.log(this.prms);
    //this.init();
  },
  watch: {
    show: function(newVal) {
      if (newVal) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      //console.log("base init here");
      //   let _objectTypeId = 0;
      //   let _id = 0;
      //   let _boxId = 0;
      //   if (this.prms != undefined && this.prms.id != 0) {
      //     _objectTypeId = this.prms.objectTypeId;
      //     _id = this.prms.id;
      //     _boxId = this.prms.boxId;
      //   } else {
      //     _objectTypeId = this.$route.params.objectTypeId;
      //     _id = this.$route.params.id;
      //     _boxId = this.$route.params.boxId;
      //   }

      //console.log("init loaded:", this.prms.objectTypeId);
      this.$nextTick(function() {
        if (this.prms.objectTypeId > 0) {
          request({
            api: { method: "get", url: "task/PreEditData" },
            params: {
              objectTypeId: this.prms.objectTypeId,
              taskId: this.prms.id,
              boxId: this.prms.boxId
            },
            store: this.$store
          }).then(res => {
            if (res != false) {
              if (this.prms.objectTypeId == 138) {
                this.otCompName = "coreEdit";
              } else if(this.prms.objectTypeId == 115) {
                this.otCompName = "lms/course"; 
              } else if(this.prms.objectTypeId == 114) {
                this.otCompName = "lms/lesson"; 
              }
              else {
                this.otCompName = res.data.task.otCompName;
              } 
              this.baseKey++;
              //console.log(this.otCompName);
            }
          });
        } else if (this.prms.objectTypeId == 0) {
          this.otCompName = "coreEdit";
        }
      });
    },
    taskPosted(e) {
      this.$emit("on-task-posted", e);
    },
    editClose() {
      //console.log("edit close from base");
      this.$emit("on-edit-close");
    }
  }
};
</script>
